module.exports = __webpack_public_path__ + "img/rooftop.c90acb14.svg";